import React, { Component } from "react";

import { Icon } from "@formant/ui/component/common/Icon";

import { reload } from "../../utils/reload";
import { IModuleMessageProps, ModuleMessage } from "../Observe/ModuleMessage";
import { StandardButton } from "./StandardButton";
import * as styles from "./WebglError.scss";

export class WebglError extends Component<IModuleMessageProps> {
    public render() {
        const { visible } = this.props;

        return (
            <ModuleMessage visible={visible} slow={true}>
                <div className={styles["webgl-error"]}>
                    <Icon
                        name="warning"
                        className={styles.icon}
                        data-tooltip="Chrome's maximum number of WebGL contexts is 16. Try refreshing the page or closing other tabs"
                    />{" "}
                    <p className={styles.label}>
                        We're having trouble starting up WebGL
                    </p>
                    <StandardButton
                        onClicked={reload}
                        className={styles.button}
                    >
                        Try Reloading
                    </StandardButton>
                </div>
            </ModuleMessage>
        );
    }
}
